import {useContext} from "react";
import MaybeNotSetupUserContext from "./maybeNotSetupUserContext";

const useMaybeNotSetupUser = () => useContext(MaybeNotSetupUserContext);

export default useMaybeNotSetupUser;
